import { MarketStatus } from '@drift-labs/sdk';
import { USDC_SPOT_MARKET_INDEX } from '@drift/common';

export const MAX_SPOT_MARKETS_PER_USER = 8;
export const MAX_SPOT_POSITIONS_ERROR_MESSAGE = {
	title: 'Max spot positions/orders reached',
	message: `You have reached the maximum number of spot positions (${MAX_SPOT_MARKETS_PER_USER}) for a single user account. This includes spot balances and open orders. To add new positions, you can: cancel existing spot orders, close spot positions, or you can create a new subaccount.`,
};

/**
 * These extra tags can be searched for in the market search bar.
 * Perp markets has full names in their market config, so we don't need to add them here.
 */
export const MARKET_TAGS = {
	spot: {
		1: ['solana'],
		2: ['marinade'],
		3: ['bitcoin'],
		4: ['ethereum'],
		5: ['tether'],
		8: ['blazesol'],
		9: ['jito'],
		10: ['dogwifhat'],
		11: ['jupiter'],
		12: ['render'],
		13: ['wormhole'],
		14: ['tensor'],
		16: ['sanctum'],
		17: ['drift'],
		18: ['ondo'],
		19: ['jupiter'],
		20: ['popcat'],
		21: ['sanctum'],
		22: ['paypal'],
		23: ['ethena'],
		24: ['ethena'],
		25: ['binance'],
		26: ['iggy', 'azalea'],
		30: ['magic', 'eden'],
		31: ['pudgy'],
		35: ['ai16z'],
		36: ['trump', 'usa'],
		37: ['melania', 'usa', 'trump'],
		38: ['agora'],
		39: ['fart'],
		54: ['euro', 'circle'],
		57: ['maple'],
	},
	perp: {
		11: ['optimism'],
		12: ['render'],
		13: ['ripple'],
		14: ['helium'],
		15: ['injective'],
		16: ['chainlink'],
		22: ['avalanche'],
		23: ['dogwifhat'],
		24: ['jupiter'],
		27: ['wormhole'],
		28: ['kamino'],
		29: ['tensor'],
		30: ['drift'],
		31: ['sanctum'],
		33: ['zeta'],
		34: ['popcat'],
		42: ['telegram'],
		44: ['iggy', 'azalea'],
		61: ['magic', 'eden'],
		62: ['pudgy'],
		63: ['ai16z'],
		64: ['trump', 'usa'],
		65: ['melania', 'usa', 'trump'],
		69: ['kaito'],
		70: ['story'],
		71: ['fart'],
		72: ['ada', 'cardano'],
		73: ['gold', 'paxg'],
		79: ['zcash'],
		80: ['mantle'],
		84: ['lighter'],
		85: ['backpack'],
	},
};

export type MarketCategory = 'all' | 'newAndTrending' | 'spot';

const COMMON_MARKET_CATEGORIES_CONFIG: {
	value: MarketCategory;
	label: string;
}[] = [
	{
		value: 'all',
		label: 'All Markets',
	},
	{
		value: 'newAndTrending',
		label: 'New & Trending',
	},
];

const SPOT_MARKET_CATEGORY: {
	value: MarketCategory;
	label: string;
} = {
	value: 'spot',
	label: 'Spot',
};

export const PERP_MARKET_CATEGORIES_CONFIG: {
	value: MarketCategory;
	label: string;
}[] = [...COMMON_MARKET_CATEGORIES_CONFIG, SPOT_MARKET_CATEGORY];

export const SPOT_MARKET_CATEGORIES_CONFIG: {
	value: MarketCategory;
	label: string;
}[] = [SPOT_MARKET_CATEGORY, ...COMMON_MARKET_CATEGORIES_CONFIG];

export const HIDDEN_MARKET_STATUSES = [
	MarketStatus.DELISTED,
	MarketStatus.SETTLEMENT,
	MarketStatus.REDUCE_ONLY,
];

// Spot market index constants
export const DRIFT_TOKEN_BANK_INDEX = 15;
export const USDE_MARKET_INDEX = 23;
export const SUSDE_MARKET_INDEX = 24;
export const BNSOL_MARKET_INDEX = 25;
export const BSOL_MARKET_INDEX = 8;
export const USDS_MARKET_INDEX = 28;
export const DSOL_MARKET_INDEX = 17;
export const JLP_MARKET_INDEX = 19;
export const EXPONENT_POOL_JITOSOL_MARKET_INDEX = 40;
export const EXPONENT_POOL_JTO_MARKET_INDEX = 44;
export const LST_POOL_JITOSOL_MARKET_INDEX = 50;
export const EURC_MARKET_INDEX = 54;
export const FRAG_SOL_MARKET_INDEX = 55;
export const KY_SOL_MARKET_INDEX = 42;
export const SYRUP_USDC_MARKET_INDEX = 57;
export const LBTC_MARKET_INDEX = 58;
export const CASH_MARKET_INDEX = 61;

export const PRIORITY_SPOT_MARKETS: Record<number, number> = {
	[USDC_SPOT_MARKET_INDEX]: 0,
	[1]: 1, // SOL
	[DSOL_MARKET_INDEX]: 2,
	[JLP_MARKET_INDEX]: 3,
	[USDS_MARKET_INDEX]: 4,
};
